import { useTranslation } from "react-i18next";
import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import Tooltip from "@mui/material/Tooltip";
import classNames from "classnames";

const LabelCell: FC<Props> = ({ element }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <div className={styles.wsStatus}>
        {element.IsOnline && (
          <Tooltip title={t("statuses.connected")}>
            <div className={classNames(styles.state, styles.connected)}></div>
          </Tooltip>
        )}
        {!element.IsOnline && (
          <Tooltip title={t("statuses.disconnected")}>
            <div
              className={classNames(styles.state, styles.disconnected)}
            ></div>
          </Tooltip>
        )}
      </div>
      {element.Label}
    </div>
  );
};

export default LabelCell;
